import React, { useState, useEffect } from "react";
import InputField from "../../components/InputField";
import Switch from "../../components/Switch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import ToolTip from "../ToolTip";
import Dropdown from "../Dropdown";
import MultipleSelectDropdown from "../MultipleSelectDropdown";

/** The production create-user form (commit 370850a), used by LegacyCreateUsersPage. */
const LegacyCreateUserForm = ({
  user,
  setUser,
  setHasChanges,
  billingGroups,
  accountTypes,
  newUser,
  onBillingGroupChange,
  onAccountTypeChange,
  onManagerChange,
  selected,
  toggleSelection,
  laptopSelections,
  toggleLaptop,
  monitorSelections,
  toggleMonitor,
  keyboardSelections,
  toggleKeyboard,
  intuneProgramSelections,
  toggleIntuneProgram,
  manualInstallationProgramSelections,
  toggleManualProgram,
  userNames,
  handleManagerChange,
  laptops,
  monitors,
  keyboards,
  intunePrograms,
  manualInstallationPrograms,
  customFields,
  setCustomFields,
  userPrograms,
  userDevices,
  setUserPrograms,
  setUserProgramsSelections,
  users,
}) => {
  const billingGroupNames = billingGroups.map((group) => group.name);
  const managerNames = users.map((user) => user.displayName);
  const accountTypeNames = accountTypes.map((type) => type.name);

  const hardware = "Hardware";
  const existingComputer = "Use existing computer";

  useEffect(() => {
    if (!selected.includes("Hardware")) {
      // Rensa hårdvaruval när checkboxen avmarkeras
      toggleLaptop(null, true); // true = reset
      toggleMonitor(null, true);
      toggleKeyboard(null, true);
    }
  }, [selected]);

  return (
    <>
      <div className="grid grid-cols-2 gap-6 w-full">
        <div className="flex flex-col gap-4">
          <label
            key="newUser"
            className="flex items-center py-2 px-3 hover:bg-blue-50 cursor-pointer"
          >
            <input
              type="checkbox"
              className="custom-checkbox-input hidden"
              checked={selected.includes("New user")}
              onChange={() => toggleSelection("New user")}
            />
            <div className="custom-checkbox mr-2">
              <svg
                className="custom-checkbox-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                ></path>
              </svg>
            </div>
            New user
          </label>

          <InputField
            label="First name"
            value={user.firstName}
            onChange={(e) => {
              setUser({ ...user, firstName: e.target.value });
              setHasChanges(true);
            }}
            placeholder="Enter first name"
            type="text"
          />

          <InputField
            label="Last name"
            value={user.lastName}
            onChange={(e) => {
              setUser({ ...user, lastName: e.target.value });
              setHasChanges(true);
            }}
            placeholder="Enter last name"
            type="text"
          />

          <InputField
            label="Email"
            value={user.email}
            onChange={(e) => {
              setUser({ ...user, email: e.target.value });
              setHasChanges(true);
            }}
            placeholder="Enter email"
            type="text"
          />

          <InputField
            label="Mobile Phone"
            value={user.mobilePhone}
            onChange={(e) => {
              setUser({ ...user, mobilePhone: e.target.value });
              setHasChanges(true);
            }}
            placeholder="Enter mobile phone"
            type="number"
          />

          <InputField
            label="Phone"
            value={user.phone}
            onChange={(e) => {
              setUser({ ...user, phone: e.target.value });
              setHasChanges(true);
            }}
            placeholder="Enter phone number"
            type="number"
          />

          <Dropdown
            label="Account types"
            value={user.accountTypeName || ""}
            options={accountTypeNames}
            onSelect={onAccountTypeChange}
            placeholder="Choose account type"
          />

          <InputField
            label="Office"
            value={user.office}
            onChange={(e) => {
              setUser({ ...user, office: e.target.value });
              setHasChanges(true);
            }}
            placeholder="Enter office"
            type="text"
          />

          {/*           <Dropdown
            label="Office"
            value={user.office}
            onChange={(e) => {
              setUser({ ...user, office: e.target.value });
              setHasChanges(true);
            }}
            placeholder="Office"
            type="text"
          /> */}

          <InputField
            label="Department"
            value={user.department}
            onChange={(e) => {
              setUser({ ...user, department: e.target.value });
              setHasChanges(true);
            }}
            placeholder="Enter department"
            type="text"
          />

          {/*           <Dropdown
            label="Department"
            value={user.department || ""}
            onChange={(e) => {
              setUser({ ...user, department: e.target.value });
              setHasChanges(true);
            }}
            placeholder="Department"
            type="text"
          /> */}

          <Dropdown
            label="Manager"
            value={user.managerName || ""}
            options={managerNames}
            onSelect={onManagerChange}
            placeholder="Choose manager"
            searchable={true}
          />

          <Dropdown
            label="Billing group"
            value={user.billingGroupName || ""}
            options={billingGroupNames}
            onSelect={onBillingGroupChange}
            placeholder="Choose billing group"
            searchable={true}
          />

          {/*                   <Dropdown
                    label="Copy user"
                    value={user.copyUser || ""}
                    onChange={(e) => {
                      setUser({ ...user, copyUser: e.target.value });
                      setHasChanges(true);
                    }}
                    placeholder="Copy user"
                    type="text"
                  />

                  <InputField
                    label="AD groups"
                    value={user.adGroups || ""}
                    onChange={(e) => {
                      setUser({ ...user, adGroups: e.target.value });
                      setHasChanges(true);
                    }}
                    placeholder="Enter AD group"
                    type="text"
                  /> */}

          <InputField
            label="Location"
            value={user.location || ""}
            onChange={(e) => {
              setUser({ ...user, location: e.target.value });
              setHasChanges(true);
            }}
            placeholder="Enter location"
            type="text"
          />

          <InputField
            label="Details"
            value={user.details || ""}
            onChange={(e) => {
              setUser({ ...user, details: e.target.value });
              setHasChanges(true);
            }}
            placeholder="Enter details"
            type="text"
          />
        </div>

        <div className="flex flex-col gap-4">
          <label
            key="hardware"
            className="flex items-center py-2 px-3 hover:bg-blue-50 cursor-pointer"
          >
            <input
              type="checkbox"
              className="custom-checkbox-input hidden"
              checked={selected.includes(hardware)}
              onChange={() => toggleSelection(hardware)}
            />
            <div className="custom-checkbox mr-2">
              <svg
                className="custom-checkbox-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                ></path>
              </svg>
            </div>
            Hardware
          </label>

          <Dropdown
            label="To whom"
            value={user.toWhom || ""}
            onChange={(e) => {
              setUser({ ...user, toWhom: e.target.value });
              setHasChanges(true);
            }}
            placeholder="To whom"
            type="text"
            searchable={true}
          />

          <InputField
            label="Desired delivery date"
            value={user.desiredDelivery || ""}
            onChange={(e) => {
              setUser({ ...user, desiredDelivery: e.target.value });
              setHasChanges(true);
            }}
            placeholder="Enter desired delivery date"
            type="date"
          />

          <label
            key="existingComputer"
            className="flex items-center py-2 px-3 hover:bg-blue-50 cursor-pointer"
          >
            <input
              type="checkbox"
              className="custom-checkbox-input hidden"
              checked={selected.includes(existingComputer)}
              onChange={() => toggleSelection(existingComputer)}
            />
            <div className="custom-checkbox mr-2">
              <svg
                className="custom-checkbox-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                ></path>
              </svg>
            </div>
            Use existing computer
          </label>
          {selected.includes("Hardware") && (
            <>
              {Array.isArray(userDevices) && userDevices.length > 0 && (
                <MultipleSelectDropdown
                  label="User devices"
                  options={(userDevices || []).map((device) => ({
                    label: device.displayName,
                    value: device.userDevicePublicId,
                  }))}
                  selected={(user.userDevices || []).map((d) =>
                    typeof d === "string" ? d : d.userDevicePublicId
                  )}
                  onChange={(selectedIds) => {
                    setUser({
                      ...user,
                      userDevices: selectedIds,
                    });
                    setHasChanges(true);
                  }}
                  placeholder="Choose user devices"
                />
              )}
              {(user.userDevices || []).length > 0 && (
                <div className="flex flex-col gap-2">
                  <label className="font-bold">Selected device links</label>
                  {(userDevices || [])
                    .filter((device) =>
                      user.userDevices.includes(device.userDevicePublicId)
                    )
                    .map((userDevice) => (
                      <a
                        key={userDevice.userDevicePublicId}
                        href={
                          userDevice.productUrl?.startsWith("http")
                            ? userDevice.productUrl
                            : `https://${userDevice.productUrl}`
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline hover:text-blue-800"
                      >
                        {userDevice.displayName}
                      </a>
                    ))}
                </div>
              )}

              {/*               <div className="flex flex-col">
                <label className="font-bold mb-2">Monitors</label>
                {monitors.map((option) => (
                  <label
                    key={option}
                    className="flex items-center py-2 px-3 hover:bg-blue-50 cursor-pointer"
                  >
                    <input
                      type="checkbox"
                      className="custom-checkbox-input hidden"
                      checked={monitorSelections.includes(option)}
                      onChange={() => toggleMonitor(option)}
                    />
                    <div className="custom-checkbox mr-2">
                      {monitorSelections.includes(option) && (
                        <svg
                          className="custom-checkbox-icon"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      )}
                    </div>
                    {option}
                  </label>
                ))}
              </div>

              <div className="flex flex-col">
                <label className="font-bold mb-2">Keyboards</label>
                {keyboards.map((keys) => (
                  <label
                    key={keys}
                    className="flex items-center py-2 px-3 hover:bg-blue-50 cursor-pointer"
                  >
                    <input
                      type="checkbox"
                      className="custom-checkbox-input hidden"
                      checked={keyboardSelections.includes(keys)}
                      onChange={() => toggleKeyboard(keys)}
                    />
                    <div className="custom-checkbox mr-2">
                      {keyboardSelections.includes(keys) && (
                        <svg
                          className="custom-checkbox-icon"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      )}
                    </div>
                    {keys}
                  </label>
                ))}
              </div> */}
            </>
          )}
          <MultipleSelectDropdown
            label="User programs"
            options={userPrograms.map((program) => ({
              label: program.displayName,
              value: program.displayName,
            }))}
            selected={(user.userPrograms || []).map((d) =>
              typeof d === "string" ? d : d.userProgramPublicId
            )}
            onChange={(selectedIds) => {
              setUser({
                ...user,
                userPrograms: selectedIds,
              });
              setHasChanges(true);
            }}
            placeholder="Choose user programs"
          />

          {/*      <MultipleSelectDropdown
            label="Manual installation programs"
            value={user.manualInstallationProgram || ""}
            onChange={(e) => {
              setUser({
                ...user,
                manualInstallationProgram: e.target.value,
              });
              setHasChanges(true);
            }}
            placeholder="Choose manual installation programs"
            type="text"
          />*/}

          <InputField
            label="Comment"
            value={user.comment || ""}
            onChange={(e) => {
              setUser({ ...user, comment: e.target.value });
              setHasChanges(true);
            }}
            placeholder="Comment"
            type="text-area"
          />
        </div>
        {/*         <div className="flex flex-col gap-2 mt-6">
          <h3 className="font-bold text-lg">Additions</h3>

          {customFields.map((field, index) => (
            <div key={index} className="flex gap-2 items-center">
              <InputField
                className="input"
                placeholder="Key"
                value={field.key}
                onChange={(e) => {
                  const updated = [...customFields];
                  updated[index].key = e.target.value;
                  setCustomFields(updated);
                  setHasChanges(true);
                }}
              />
              <InputField
                className="input"
                placeholder="Value"
                value={field.value}
                onChange={(e) => {
                  const updated = [...customFields];
                  updated[index].value = e.target.value;
                  setCustomFields(updated);
                  setHasChanges(true);
                }}
              />
              <button
                className="btn btn-outline-primary"
                onClick={() => {
                  const updated = customFields.filter((_, i) => i !== index);
                  setCustomFields(updated);
                  setHasChanges(true);
                }}
              >
                Remove
              </button>
            </div>
          ))}

          <button
            className="btn btn-primary mt-2"
            onClick={() =>
              setCustomFields([...customFields, { key: "", value: "" }])
            }
          >
            + Add Field
          </button>
        </div> */}
      </div>
    </>
  );
};

export default LegacyCreateUserForm;
